import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Sidebar from './pages/Sidebar';
import Home from './pages/Home';
import Root from './pages/Root';
import Consequences from './pages/Consequences';
import Research from './pages/Research';
import About from './pages/About';
import Interview from './pages/Interview';
import Survey from './pages/Survey';
import UploadDocuments from './pages/UploadDocuments';
import './App.css';

import { Amplify } from 'aws-amplify';
import { Authenticator, withAuthenticator } from '@aws-amplify/ui-react';
import '@aws-amplify/ui-react/styles.css';
import awsExports from './aws-exports';
Amplify.configure(awsExports);

function App() {
  return (
    <Router>
      <div className="App">
        <Authenticator>
          {({ signOut }) => (
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/root" element={<WithSidebar signOut={signOut}><Root /></WithSidebar>} />
              <Route path="/consequences" element={<WithSidebar signOut={signOut}><Consequences /></WithSidebar>} />
              <Route path="/research" element={<WithSidebar signOut={signOut}><Research /></WithSidebar>} />
              <Route path="/interview" element={<WithSidebar signOut={signOut}><Interview /></WithSidebar>} />
              <Route path="/survey" element={<WithSidebar signOut={signOut}><Survey /></WithSidebar>} />
              <Route path="/upload-documents" element={<WithSidebar signOut={signOut}><UploadDocuments /></WithSidebar>} />
              <Route path="/about" element={<WithSidebar signOut={signOut}><About /></WithSidebar>} />
              
              {/* // <Route path="/" element={<Home />} />
              // <Route path="/root" element={<WithSidebar ><Root /></WithSidebar>} />
              // <Route path="/consequences" element={<WithSidebar ><Consequences /></WithSidebar>} />
              // <Route path="/research" element={<WithSidebar ><Research /></WithSidebar>} />
              // <Route path="/interview" element={<WithSidebar ><Interview /></WithSidebar>} />
              // <Route path="/survey" element={<WithSidebar ><Survey /></WithSidebar>} />
              // <Route path="/upload-documents" element={<WithSidebar ><UploadDocuments /></WithSidebar>} />
              // <Route path="/about" element={<WithSidebar ><About /></WithSidebar>} /> */}
              
            </Routes>
          )}
        </Authenticator>
      </div>
    </Router>
  );
}

const WithSidebar = ({ children, signOut }) => (
  <div className="main-content">
    <Sidebar signOut={signOut} />
    <div className="main-content">{children}</div>
  </div>
);

export default withAuthenticator(App);
// export default App;